import Vue from 'vue'
import Router from 'vue-router'



Vue.use(Router)
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
export default new Router({ 
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/pages/Home')
    },

    {
      path: '/policyment',
      name: 'policyment',
      component: () => import('@/pages/policyment')
    },
    {
      path: '/emergency',
      name: 'emergency',
      component: () => import('@/pages/emergency')
    },
    {
      path: '/prevention',
      name: 'prevention',
      component: () => import('@/pages/prevention')
    },

    {
      path: '/applypag',
      name: 'applypag',
      component: () => import('@/pages/applypag')
    },
    {
      path: '/newlist',
      name: 'newlist',
      component: () => import('@/pages/newlist')
    },
    {
      path: '/realtime',
      name: 'realtime',
      component: () => import('@/pages/realtime')
    },
    {
      path: '/earthquake',
      name: 'earthquake',
      component: () => import('@/pages/earthquake')
    },
    {
      path: '/prevention',
      name: 'prevention',
      component: () => import('@/pages/prevention')
    },
    {
      path: '/society',
      name: 'society',
      component: () => import('@/pages/society')
    },
    {
      path: '/yearbooks',
      name: 'yearbooks',
      component: () => import('@/pages/yearbooks')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/login')
    },
    {
      path: '/personal',
      name: 'personal',
      component: () => import('@/pages/personal')
    },
    {
      path: '/database',
      name: 'database',
      component: () => import('@/pages/database')
    },
    {
      path: '/searchlist',
      name: 'searchlist',
      component: () => import('@/pages/searchlist')
    },
    {
      path: '/dataVisualization',
      name: 'dataVisualization',
      component: () => import('@/pages/dataVisualization/index'),
      redirect: '/dataVisualization/realTime',
      children: [
        {
          path: '/dataVisualization/realTime',
          name: 'RealTime',
          component: () => import('@/pages/dataVisualization/realTime'),
          meta: {
            title: '灾害速报', 
            affix: true,
            noKeepAlive: true,
          },
        },
        {
          path: '/dataVisualization/earthquakeData',
          name: 'EarthquakeData',
          component: () => import('@/pages/dataVisualization/earthquakeData'),
          meta: {
            title: '地震灾害', 
            affix: true,
            noKeepAlive: true,
          },
        },
        {
          path: '/dataVisualization/preventionData',
          name: 'PreventionData',
          component: () => import('@/pages/dataVisualization/preventionData'),
          meta: {
            title: '地震灾害', 
            affix: true,
            noKeepAlive: true,
          },
        },
        {
          path: '/dataVisualization/economyData',
          name: 'EconomyData',
          component: () => import('@/pages/dataVisualization/economyData'),
          meta: {
            title: '地震灾害', 
            affix: true,
            noKeepAlive: true,
          },
        }
        
        
      ],
    }

  ],         
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js